var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',[(_vm.to===undefined)?[_vm._v(" "+_vm._s(_vm.label)+" ")]:[_c('a',{attrs:{"href":_vm.to}},[_vm._v(_vm._s(_vm.label))]),_c('i',{staticClass:"fa fa-circle"})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }